const oAuthConstants= {};
var currentFullBaseUrl = (location.protocol+'//'+location.host);

const authority = {
    prod: currentFullBaseUrl,
    local: 'https://idam-dev.metrosystems.net'
};

oAuthConstants.authority = authority[ENV_VAR || 'prod'];
oAuthConstants.scopes = ['openid', 'profile', 'clnt=IDAM_LOGIN_PREFS'];
oAuthConstants.nonce = 'nonce';
oAuthConstants.grant_type = 'implicit';
oAuthConstants.grant_type_v2 = 'authorization_code';
oAuthConstants.clientId = 'IDAM_LOGIN_PREFS';
oAuthConstants.aud = 'IDAM_LOGIN_PREFS';
oAuthConstants.redirectUri = currentFullBaseUrl + '/web/loginprefsredirect';
oAuthConstants.response_type = 'code';
oAuthConstants.postLogoutRedirectUri = currentFullBaseUrl + '/web/loginprefsredirect/';
oAuthConstants.code_challenge_method = 'S256';
oAuthConstants.tokenType = 'Bearer ';
oAuthConstants.accessTokenKey = 'access_token_lp';
oAuthConstants.idTokenKey = 'id_token';
oAuthConstants.accessTokenInfo ='access_token_info';
oAuthConstants.sessionStateKey ='session_state_lp';
oAuthConstants.openid_configuration = 'openid_configuration_lp'
oAuthConstants.checkSessionInterval = 5; // in minutes
oAuthConstants.accessTokenExpiringNotificationTime = 10; // in minutes
oAuthConstants.IDAMRolePrefix = 'IDAM';
oAuthConstants.silentRequestTimeout = 10; // in sec

module.exports =  oAuthConstants;